import { useQuery } from '@tanstack/vue-query';
import { queries } from '@/api/queries';
import { getApiV2RestaurantsId } from '@/api/pensa';

const useGetRestaurant = (restaurantId: Ref<string | null>) => {
  const enabled = computed(() => !!restaurantId.value);
  return useQuery({
    ...queries.takeaway.restaurant(restaurantId),
    queryFn: () => getApiV2RestaurantsId(restaurantId.value!),
    enabled,
  });
};

export default useGetRestaurant;
